export { default } from './SlidePagination';



// WEBPACK FOOTER //
// ./src/components/atoms/SlidePagination/index.js